import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.MobileDecisionPageContent', {
    mobileAppTipText: 'Would you like to try the ApprovalMax mobile app?',
});
